document.addEventListener("turbolinks:load", function () {
  const dot_btn = document.getElementById("dot-menu-btn")
  dot_btn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    document.body.classList.toggle('dot-menu-visible');
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.id != "dot-menu-btn") {
      document.body.classList.remove('dot-menu-visible');
    }
  });

  document.addEventListener("turbolinks:before-cache", function () {
    document.body.classList.remove('dot-menu-visible');
  })
});
